import app from 'flarum/forum/app';
import AcceptTermsModal from './AcceptTermsModal';
import LoadStripe from '../../common/loadStripe';
export default class Handler {
  checkoutUrl = app.forum.attribute('apiUrl') + '/floxum-payments/stripe/checkout';
  constructor(type, params) {
    this.type = type;
    this.params = params;
  }
  checkout() {
    if (app.forum.blomstraLinkToTerms()) {
      app.modal.show(AcceptTermsModal, {
        onsubmit: () => {
          this.doCheckout();
        } // @ts-ignore stack it for Flarum v1.5 as bounties already open a modal.
      }, true);
    } else {
      this.doCheckout();
    }
  }
  doCheckout() {
    const params = this.params || {};
    params.type = this.type;
    app.request({
      url: this.checkoutUrl,
      method: 'POST',
      body: params
    }).then(this.redirect.bind(this));
  }
  redirect(response) {
    const sessionId = response.session_id;
    LoadStripe().then(stripe => stripe.redirectToCheckout({
      sessionId
    }));
  }
}
flarum.reg.add('floxum-payments', 'forum/Checkout/Handler', Handler);